import { Trip } from "@cruisen/react-shared"
import { Buffer } from "buffer"

export const getSearchCriteriaHash = (trip: Trip) => {
  const hashData = {
    originPortGroups: trip?.originPortGroups.map((group) => group.id),
    destinationRegions: trip?.destinationRegions.map((region) => region.id),
    months: trip?.months,
    roomGuests: trip?.rooms.map((room) => ({
      roomId: room.id,
      guests: room.guests.map((guest) => guest.id),
    })),
  }

  return Buffer.from(JSON.stringify(hashData)).toString("base64")
}
